// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"472":"ceef65aa","517":"ceef65aa","558":"ceef65aa"}[chunkId] + ".chunk.css";
};